module.exports = __webpack_public_path__ + "static/media/cognitive.27dbf581.gif";